import React from 'react';
import ReactDOM from 'react-dom';


let timerVO = ' ';

const _delete = () => {
  const manager = document.getElementById('cybs-screenreader-manager');
  if (manager) {
    ReactDOM.render(<>&nbsp;</>, manager);
  } else {
    // eslint-disable-next-line no-use-before-define
    _initialize('');
  }
};

const _render = message => {
  clearTimeout(timerVO);

  const manager = document.getElementById('cybs-screenreader-manager');

  if (manager) {
    ReactDOM.render(<>{message}</>, manager, () => {
      timerVO = setTimeout(() => _delete(), 1000);
    });
  } else {
    // eslint-disable-next-line no-use-before-define
    _initialize(message);
  }
};

const _initialize = (message = '') => {
  if (!document.querySelector('#cybs-screenreader-manager')) {
    const managerVO = document.createElement('div');
    managerVO.setAttribute('aria-live', 'assertive');
    managerVO.setAttribute('class', 'cybs-a11y-hidden');
    managerVO.setAttribute('id', 'cybs-screenreader-manager');
    document.querySelector('body').appendChild(managerVO);
  }
  _render(message);
};

// create the export variable with included public functions
const CybsScreenReaderManagerClass = {
  addNotification(message) {
    _render(message);
  }
};

// initialize the voiceover manager in the DOM
_initialize();

export default CybsScreenReaderManagerClass;
